// FileViewerModal.js
import React, { useEffect, useState, useRef } from "react";
import { Modal, Box, Backdrop, CircularProgress } from "@mui/material";
import { isEmptyDash, urlConstants } from "../../constant";
import AlertComponent from "../alert/alert";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { UserObj } from "../../services/localStarage";
import _ from "lodash";

const requestesignstyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};


const POReleaseModal = (props) => {
  const userRole = UserObj ? UserObj?.role?.name : "";
  const [fileSrc, setfileSrc] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  const handleCloseAlert = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };

  const submit = (param) => {
    if (isEmptyDash(selectedFile)) {
      setAlertComponent(true, "error", `Please select a valid file.`);
      return;
    }
    props.submitRelease(selectedFile);
  }

  useEffect(() => {
    if (!isEmptyDash(props?.purchaseOrderIds) && props.isOpen == true) {
      downloadPO();
    }
  }, [props?.purchaseOrderIds, props.isOpen]);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
    const urlInit = URL.createObjectURL(e.target.files[0]);
    setfileSrc(urlInit);
  }

  const downloadPO = () => {
    // const urlInit = URL.createObjectURL(blob); 
    // setfileSrc(urlInit); 
  }

  const closeModal = (e) => {
    props.closeReleaseModal();
    setfileSrc(null);
    // setIsChecked(false);
  };


  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  return (
    <div>
      <Modal
        open={props.isOpen}
        onClose={closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={requestesignstyle}
          className="modal_realease_desciption_row"
        >
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="exampleModalLabel">
              Release
            </h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              fdprocessedid="kum8iho"
              onClick={closeModal}
            ></button>
          </div>
          <div className="first_main_rowmodal">
            <div class="modal-body">
              <p class="project_Manager_biddings">Signed PO PDF</p>
              <div className="from_input_realse">
                <input
                  class="form-control form-h choose"
                  type="file"
                  id="checklist-fileInput"
                  accept=".bmp,.gif,.jpg,.jpeg,.png,.tiff,.psd,.svg,.eps,.ai,.pdf"
                  onChange={handleFileChange}
                />
              </div>
              {(fileSrc != null) && <div className="">
                <div className="miles_order_reader_release_modaldetail w-100" >
                  <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
                    <div>
                      <Viewer fileUrl={fileSrc} plugins={[defaultLayoutPluginInstance]} />
                    </div>
                  </Worker>
                </div>
              </div>}
              <div className="div-tnc">
                <div className="card_tabs_milstone">
                  <button
                    class="btn btn-outline-secondary"
                    onClick={closeModal}
                  >
                    Discard
                  </button>
                  <button
                    type="button"
                    class="btn btn-success save_next_btns"
                    onClick={submit}
                  >
                    Release
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleCloseAlert}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => 99999 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default POReleaseModal;
